export const hasValue = (value: unknown): boolean => (Array.isArray(value) ? value.length > 0 : value != null);
